import { useMemo } from 'react';
import type { PropsWithChildren } from 'react';
import type React from 'react';

import { UserAgentContextProvider as UserAgentContextProviderBase } from './context';
import type { UserAgentContextValue } from './context';

export const UserAgentContextProvider: React.FC<PropsWithChildren<UserAgentContextValue>> = ({ children, bot }) => {
	const value = useMemo(() => ({ bot }), [bot]);

	return <UserAgentContextProviderBase value={value}>{children}</UserAgentContextProviderBase>;
};
